/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

(function() {
   
  var ProductGallery = function() {
    var $carousel = $('.custom-product-thumb .product__submedia-list').flickity({
      // options
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: false
    });
    
      $carousel.flickity('resize')
    
  };

  setTimeout(function(){
    ProductGallery();
  },1500);

  $(document).on('shopify:section:load', function(event) { 
    ProductGallery();
  });
}());